export default "__VITE_ASSET__CndLiGRZ__"